/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MediaSchema
 */
export interface MediaSchema {
    /**
     * 
     */
    s3Key: string;
    /**
     * 
     */
    url: string | null;
    /**
     * 
     */
    filename: string | null;
    /**
     * 
     */
    contentType: string | null;
}

/**
 * Check if a given object implements the MediaSchema interface.
 */
export function instanceOfMediaSchema(value: object): value is MediaSchema {
    if ((!('s3Key' in (value as Record<string, any>)) && !('s3_key' in (value as Record<string, any>))) || ((value as Record<string, any>)['s3Key'] === undefined && (value as Record<string, any>)['s3_key'] === undefined)) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if ((!('contentType' in (value as Record<string, any>)) && !('content_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['contentType'] === undefined && (value as Record<string, any>)['content_type'] === undefined)) return false;
    return true;
}

export function MediaSchemaFromJSON(json: any): MediaSchema {
    return MediaSchemaFromJSONTyped(json, false);
}

export function MediaSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaSchema {
    if (json == null) {
        return json;
    }
    return {
        
        's3Key': json['s3_key'],
        'url': json['url'],
        'filename': json['filename'],
        'contentType': json['content_type'],
    };
}

export function MediaSchemaToJSON(json: any): MediaSchema {
    return MediaSchemaToJSONTyped(json, false);
}

export function MediaSchemaToJSONTyped(value?: MediaSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        's3_key': value['s3Key'],
        'url': value['url'],
        'filename': value['filename'],
        'content_type': value['contentType'],
    };
}

